import { ClaimCategories } from '~/classes/literals'

export const homeFormsFilterTabsTrigger = [
    {
        label: 'Motor Vehicles',
        value: ClaimCategories.Motor,
    },

    {
        label: 'Glass Only',
        value: ClaimCategories.GlassOnly,
    },
]

export const vehicleTabTrigger = [
    {
        label: 'Motor Car',
        value: 'car',
    },

    {
        label: 'PickUp',
        value: 'pickup',
    },
]
